import React, { useEffect, useState } from "react";
import { getDeliveryReqListApi } from "../../../Api/PanelAdminServices";
import { errorToast } from "./../../../Utils/Toast/Toast";
import { Modal } from "react-bootstrap";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import AllDeliveyRequestTable from "../../Tables/Deliver/AllDeliveryRequestTable/AllDeliveryRequestTable";
import DeliveryRequestDetail from "./DeliveryRequestDetail/DeliveryRequestDetail";

const AllDeliveyRequestContainer = () => {
  const [travelsState, setTravelsState] = useState([]);
  const [travelDetaiModalState, setTravelDetaiModalState] = useState(false);
  const [travelId, setTravelId] = useState(false);
  const getDataHandler = () => {
    getDeliveryReqListApi((res) => {
      if (res.status === 1) {
        setTravelsState(res.requests.sort((a,b)=>b.id-a.id));
      } else {
        errorToast(res.message);
      }
    });
  };
  useEffect(() => {
    getDataHandler();
  }, []);
  const openModalHandler = (record) => {
    setTravelDetaiModalState(true);
    setTravelId(record.id)
  };

  return (
    <div className="w-100 bg-white d-flex flex-column align-items-center py-3">
        <TableFixedPage title={"همه درخواست های پیک"} />
      <Modal
        className="RTL"
        show={travelDetaiModalState}
        size="xl"
        onHide={() => setTravelDetaiModalState(false)}
      >
        <Modal.Header>
          <Modal.Title className="w-100 fs-6">جزئیات درخواست</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeliveryRequestDetail requestId={travelId}/> 
        </Modal.Body>
      </Modal>
      <AllDeliveyRequestTable data={travelsState} modalHandler={openModalHandler} />
    </div>
  );
};

export default AllDeliveyRequestContainer;
